const theme = {
  accent: "#8ad6f0",
  text: "#525252",
  offblack: "#222222",
  lightGray: "#d6d6d6",
  mainBg: "#FCFCFC",

  shadow: "0px 0px 3px 2px rgba(0, 0, 0, 0.05);",

  margin: 2.5,

  yellow: "#ffe98a",
  pink: "#ff94c1",
  magenta: "#da0e8a",
  blue: "#1b8bcf",
  aqua: "#00aaad"
};

export default theme;
